//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myQaQuestionAction from '../action/myQaQuestionAction';
import * as myQaAnswerAction from '../action/myQaAnswerAction';
import * as partnerAction from '../action/partnerAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
//Add
import moment from 'moment';
import ReactPaginate from 'react-paginate';
//Menu
import MenuMyProfile from './MenuMyProfile';
import MenuMyQa from './MenuMyQa';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import CancelIcon from '@material-ui/icons/Cancel';


class Comp extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
      answerDelQaId: null,
    }

	}

  componentDidMount() {
    document.title = 'Q&A(回答) - パートナーズ';
    if (this.props.history.action === "POP") {
      if (this.props.my.qaAnswer.list.length === 0) {
        this.props.myQaAnswerListGet(1);
      }
    }
    else {
      this.props.myQaAnswerListGet(1);
    }
  }



  _onPaging(page) {
    this.props.myQaAnswerListGet(page);
    window.scrollTo(0, 0);
  }

  _partnerQaQuestionAnswerDelSubmit() {
    this.props.partnerQaQuestionAnswerDel(this.state.answerDelQaId, () => {
      this.setState({answerDelQaId: null});
    })
  }

  _renderList(value, index) {
    return (
      <div key={index} style={{margin:'15px'}}>
        <Box className='postItem round12' boxShadow={2} style={{background:'#FFF'}}>
          <div style={{padding:'10px'}}>
          <div>
            {
              (moment(value.answer_date).isValid()) && (
                moment(value.answer_date).format("YYYY年MM月DD日")
              )
            }
          </div>
            <div style={{padding:'5px',fontSize:'1.1em',fontWeight:'bold',color:'#666'}}>
              Q. {value.question_comment}
            </div>
            <div style={{margin:'5px'}}>
              {
                (Array.isArray(value.answer_except_arr) === true) && (
                  value.answer_except_arr.map(
                    (value, index) => {return (<div key={index} style={{color:'#666'}}>A. {value}</div>)}
                  )
                )
              }
            </div>
            <div style={{padding:'5px',fontSize:'1.1em'}}>
              <span className='orange_icon'>回答</span> {value.answer_comment}

              <CancelIcon
                onClick={ () => this.setState({answerDelQaId:value.question_id}) }
                style={{
                  verticalAlign:'middle',
                  cursor:'pointer',
                  color:'#ccc',
                }}
              />
            </div>
          </div>
        </Box>
      </div>
    )
  }


  render() {
    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <MenuMyProfile />
        <MenuMyQa />

        {
          (this.props.my.qaAnswer.list.length > 0) ? (
            <div>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent: 'space-between',
                  margin: '10px',
                }}
              >
                <div>
                  { this.props.my.qaAnswer.count }件
                </div>
                <div>
                  <span style={{color:'#666'}}>ページ{this.props.my.qaAnswer.page}</span>
                  <IconButton
                    onClick={ () => this.props.myQaAnswerListGet(1) }
                  >
                    <RefreshIcon />
                  </IconButton>
                </div>
              </div>


              {
                this.props.my.qaAnswer.list.map((value, index) =>
                  this._renderList(value, index)
                )
              }

              {
                (Math.ceil(this.props.my.qaAnswer.count / 10) > 1) && (
                  <div align='center' style={{margin:'15px'}}>
                    <ReactPaginate
                      breakLabel="…"
                      previousLabel="<"
                      nextLabel=">"
                      onPageChange={ (event) => this._onPaging((event.selected + 1)) }
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={ Math.ceil(this.props.my.qaAnswer.count / 10) }
                      renderOnZeroPageCount={null}
                      containerClassName={'pagingBlock'}
                      pageLinkClassName={'item'}
                      previousLinkClassName={'item'}
                      nextLinkClassName={'item'}
                      activeLinkClassName={'select'}
                      disabledClassName={'itemDisabled'}
                    />
                  </div>
                )
              }
            </div>
          ) : (
            <div style={{padding:'10px'}}>
              <h2 align='center' style={{margin:'5px'}}>
                Q&Aの回答(公開中)はありません
              </h2>
              <div align='center' style={{margin:'5px'}}>
                みんなのQ&Aから質問に回答すると<br />
                プロフィールに回答が掲載できます。
              </div>
              <div align='center' style={{margin:'5px'}}>
                <Button
                  variant="contained"
                  color='primary'
                  onClick={ () => this.props.history.push('/community/qa/') }
                >
                  みんなのQ&Aに回答する
                </Button>
              </div>
            </div>

          )

        }


        <DialogConfirm
          open={ (this.state.answerDelQaId) ? true : false }
          title={'Q&Aの回答を削除'}
          content={'Q&Aの回答を1件削除してもいいですか？'}
          apply={ () => this._partnerQaQuestionAnswerDelSubmit() }
          close={ () => this.setState({answerDelQaId: null}) }
        />

      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myQaQuestionAction,
    ...myQaAnswerAction,
    ...partnerAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
